import { createFileRoute } from "@tanstack/react-router";
import { ArquivosPage } from "@/paginas/arquivos";

export const Route = createFileRoute("/_authenticated/arquivos")({
  head: () => ({
    meta: [
      { title: "Arquivos — Milky Moo Palmares" },
      {
        name: "description",
        content: "Navegue pelas pastas e arquivos do repositório configurado da sorveteria.",
      },
      { property: "og:title", content: "Arquivos — Milky Moo Palmares" },
      {
        property: "og:description",
        content: "Navegue pelas pastas e arquivos do repositório configurado da sorveteria.",
      },
      { property: "og:type", content: "website" },
      { name: "twitter:card", content: "summary" },
    ],
  }),
  component: ArquivosPage,
});
